import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import Radio from '@material-ui/core/Radio'
import styles from './styles'
import data from './data'
import { useSelector } from 'react-redux'
const StyledRadio = withStyles({
  root: {
    //color: green[400],
    '&$checked': {
      color: '#015FFB',
    },
  },
  checked: {},
})(props => <Radio color="default" {...props} />)

const Selections = props => {
  const { classes, handleBadgeUsageType, badgeUsageType } = props
  const loadingState = useSelector(state => state.card.editorLoading)

  const handleClickOnBadge = badgeId => {
    if (loadingState) {
      // If editor is loading, delay the function call by 2 seconds
      setTimeout(() => {
        handleBadgeUsageType(badgeId)
      }, 2000)
    } else {
      // If not loading, call immediately
      handleBadgeUsageType(badgeId)
    }
  }

  return (
    <div className={classes.root}>
      {data.map(item => (
        <div
          className={classes.root_content}
          onClick={() => handleClickOnBadge(item.id)}
          style={{
            border:
              badgeUsageType == item.id
                ? '1px solid #015FFB'
                : '1px solid #E0E0E0',
          }}
        >
          <div>
            <StyledRadio
              checked={badgeUsageType == item.id}
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'A' }}
            />
          </div>

          <div className={classes.root_content_text}>
            <Typography className={classes.root_content_text_title}>
              {item.title}
            </Typography>
            <Typography className={classes.root_content_text_description}>
              {item.description}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  )
}

export default withStyles(styles)(Selections)
